import { env } from 'src/config/env';
export const getModuleExternalId = (id?: string | number): string => {
  if (!id) {
    return '';
  }

  const isProd = env.mode === 'production';
  if (isProd) {
    return id.toString();
  }
  return `test_${id}`;
};
